import { useSelector } from 'react-redux';
export const useGetSpecificCrossTabState = (key) => useSelector((state) => state?.crossTabs?.crossStates?.[key]);
export const useGetCrossTabStates = () => useSelector((state) => {
    return state?.crossTabs?.crossStates;
});
